import { IonCol, IonRow } from "@ionic/react";
import React, { useEffect, useState } from "react";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import Spacer from "../../../../components/spacer";
import CustomTooltip from "./components/CustomTooltip";
import { prepareBitesFreqGraph } from "./utils";
// import CustomTooltip from "./components/CustomTooltip";

interface props {
	entries: any;
	labels: any;
}

const ChartsEating: React.FC<props> = ({ entries, labels }) => {
	const [freqGraph, setFreqGraph] = useState<any>({});

	useEffect(() => {
		if (entries) {
			setFreqGraph(prepareBitesFreqGraph(entries));
		}
	}, [entries]);

	return (
		<>
			<IonRow>
				<IonCol>
					<Spacer size="30" />
					<div>
						<h2 className="chart-title">Frequency of Bites</h2>
						<ResponsiveContainer
							width="100%"
							height="100%"
							minWidth="300px"
							minHeight="300px"
						>
							<LineChart
								width={600}
								height={600}
								data={freqGraph}
								margin={{
									top: 5,
									right: 30,
									left: 20,
									bottom: 5,
								}}
							>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="name" />
								<YAxis />
								<Tooltip
									content={
										<CustomTooltip
											active={""}
											payload={""}
											label={""}
											labels={labels}
										/>
									}
								/>
								<Legend
									margin={{
										top: 5,
										right: 30,
										left: 20,
										bottom: 5,
									}}
								/>
								<Line type="monotone" dataKey="frequency" stroke="#8884d8" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				</IonCol>
			</IonRow>
		</>
	);
};

export default ChartsEating;
